import React from "react";
import Reveal from "./Reveal";

const COLLABORATORS = [
  "Monte Real Club de Yates de Baiona",
  "Puerto Banús",
  "Puerto Sherry",
  "Marina Coruña",
  "Marina Viveiro",
  "Nova Dársena Esportiva de Bara",
  "Club Náutico de L'Ametlla de Mar",
  "Club Náutico de Santa Ponsa",
  "Calero Marinas",
  "Marina La Palma",
  "Marina Lanzarote",
  "Marina Jandía",
  "Pasito Blanco",
  "Puerto Deportivo de La Duquesa",
  "Puerto Deportivo Marina del Este",
  "Puerto Deportivo Marina de Estepona",
  "Marina del Sur, Puerto de Las Galletas",
  "Alcaidesa",
  "Amarillo Marinas",
  "Puerto Chico, Tenerife",
  "Marina La Gomera",
  "Varaderos del Sur",
];

const COLLAB_IMG =
  "https://images.pexels.com/photos/11622005/pexels-photo-11622005.jpeg?auto=compress&cs=tinysrgb&w=1600";

const Collaborations = () => {
  return (
    <section
      id="colaboraciones"
      data-testid="section-collaborations"
      className="py-24 sm:py-32 bg-white relative overflow-hidden"
    >
      {/* Decorative watermark */}
      <div className="absolute right-0 -top-8 font-display text-[14rem] lg:text-[18rem] leading-none text-navy/[0.025] select-none pointer-events-none -mr-8">
        05
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center mb-16">
          <div className="lg:col-span-7">
            <Reveal>
              <div className="flex items-center gap-3 mb-5">
                <div className="h-px w-10 bg-sky" />
                <div className="text-xs uppercase tracking-[0.28em] text-sky font-semibold">
                  05 — Colaboraciones
                </div>
              </div>
            </Reveal>
            <Reveal delay={120}>
              <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-navy leading-[1.1] tracking-tight">
                Puertos, marinas y clubes náuticos{" "}
                <span className="italic text-navy/70">con los que hemos trabajado</span>.
              </h2>
            </Reveal>
            <Reveal delay={200}>
              <p className="mt-6 text-ink-muted text-base lg:text-lg leading-relaxed">
                PORT&rsquo;S COLLECTORS ha colaborado con diferentes puertos, marinas y clubes
                náuticos en la gestión de asuntos vinculados a embarcaciones, amarres y
                procedimientos del sector portuario.
              </p>
            </Reveal>
          </div>
          <Reveal delay={200} className="lg:col-span-5">
            <div className="relative aspect-[5/4] rounded-sm overflow-hidden shadow-2xl group">
              <img
                src={COLLAB_IMG}
                alt="Marina con yates amarrados"
                className="w-full h-full object-cover transition-transform duration-[2000ms] ease-out group-hover:scale-105"
                data-testid="collaborations-image"
              />
              <div className="absolute inset-0 ring-1 ring-inset ring-navy/10" />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-navy-900/80 via-navy-900/30 to-transparent p-6">
                <div className="text-white/90 text-xs uppercase tracking-[0.28em] font-semibold">
                  22 entidades en España
                </div>
              </div>
            </div>
          </Reveal>
        </div>

        <Reveal>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 border-t border-l border-slate-200">
            {COLLABORATORS.map((name, idx) => (
              <div
                key={name}
                data-testid={`collaborator-${idx}`}
                className="group relative flex items-center px-6 py-5 border-r border-b border-slate-200 hover:bg-surface-alt transition-colors overflow-hidden"
              >
                <span className="absolute left-0 top-0 bottom-0 w-0 bg-sky/[0.08] group-hover:w-full transition-all duration-500 -z-10" />
                <span className="text-sky mr-4 font-display text-sm tabular-nums">
                  {String(idx + 1).padStart(2, "0")}
                </span>
                <span className="text-ink text-sm sm:text-[15px] leading-snug group-hover:text-navy group-hover:translate-x-1 transition-all">
                  {name}
                </span>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Collaborations;
